import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import USAState from './components/USAState';
import data from './data/usa-map-dimensions';

const USAMap = ({
    onClick,
    width = 959,
    height = 593,
    defaultFill = '#C1C1C1',
    customize = {},
}) => {
    const clickHandler = useCallback((stateAbbreviation) => {
        if (!onClick) {
            return;
        }

        onClick(stateAbbreviation);
    }, [onClick]);

    const fillStateColor = useCallback((state) => {
        if (customize && customize[state] && customize[state].fill) {
            return customize[state].fill;
        }

        return defaultFill;
    }, [customize, defaultFill]);

    const stateClickHandler = useCallback((state) => {
        if (customize && customize[state] && customize[state].clickHandler) {
            return customize[state].clickHandler;
        }

        return clickHandler;
    }, [customize, clickHandler]);

    const buildPaths = useCallback(() => {
        const paths = [];
        const dataStates = data();
        for (const stateKey in dataStates) {
            if (Object.prototype.hasOwnProperty.call(dataStates, stateKey)) {
                const path = <USAState key={stateKey} stateName={dataStates[stateKey].name} dimensions={dataStates[stateKey].dimensions} state={stateKey} fill={fillStateColor(stateKey)} onClickState={stateClickHandler(stateKey)} />;
                paths.push(path);
            }
        }

        return paths;
    }, [fillStateColor, stateClickHandler]);

    return (
        <svg
            className="us-state-map"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 959 593"
            role="img"
            aria-label="US State Map"
            aria-hidden="true"
        >
            <g className="outlines">
                {buildPaths()}
                <g className="DC state">
                    <path className="DC1" fill={fillStateColor('DC1')} d="M801.8,253.8 l-1.1-1.6 -1-0.8 1.1-1.6 2.2,1.5z" />
                    <circle className="DC2" data-name="DC" fill={fillStateColor('DC2')} stroke="#FFFFFF" strokeWidth="1.5" cx="801.3" cy="251.8" r="5" opacity="1" onClick={clickHandler} />
                    <title>Washington DC</title>
                </g>
            </g>
        </svg>
    );
};

USAMap.propTypes = {
    onClick: PropTypes.func,
    width: PropTypes.number,
    height: PropTypes.number,
    defaultFill: PropTypes.string,
    customize: PropTypes.object,
};

export default React.memo(USAMap);
